
export default {
	data() {
    return {
    	
    }
  },
  props: ['company'],
  computed:{
    notInUserCall() {
      return !this.$store.state.user.companies_calls.includes(this.$store.state.company.company.id)
    }
  }
}